// config options for the useSessionStorage hook from usehooks-ts
// useSessionStorage uses JSON.stringify and JSON.parse to serialize and deserialize
// session storage values by default, but JSON.parse doesn't work with string value
// See https://github.com/juliencrn/usehooks-ts/issues/335 for more details
// These options are used to configure the hook so that it can work with string values
export const sessionStorageStringSerializer = {
  serializer: (value: string | null) => value || '',
  deserializer: (value: string) => value || null,
}
